var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoverElement",on:{"mouseover":function($event){return _vm.updateHover(_vm.setting, true)},"mouseleave":function($event){return _vm.updateHover(_vm.setting, false)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }